<template>
  <div class="pa-10 relative">
    <v-overlay
      v-model="UNDER_CONSTRUCTION"
      contained
      persistent
      class="align-center justify-center under-construction-overlay"
    >
      <h1 class="bg-white text-grey-darken-3 opacity-90 px-6 py-4 rounded">
        Under Construction
      </h1>
    </v-overlay>
    <v-row class="align-center">
      <v-icon icon="system_update_alt" class="ml-5" color="#aaaaaa"></v-icon>
      <v-btn-toggle
        v-model="toggle_load"
        class="ml-2"
        variant="outlined"
        divided
        mandatory
        :disabled="port_disabled"
        shaped
      >
        <v-btn
          size="small"
          class="mt-2 mb-2 pa-2"
          @click="load_log_data_1m('All')"
          >All
          <v-tooltip activator="parent" location="bottom"
            >All data<br />interval : 1 minute</v-tooltip
          >
        </v-btn>
        <v-btn
          size="small"
          class="mt-2 mb-2 pa-2"
          @click="load_log_data_1m('7d')"
          >7d
          <v-tooltip activator="parent" location="bottom"
            >7days ago<br />interval : 1 minute</v-tooltip
          >
        </v-btn>
        <v-btn
          size="small"
          class="mt-2 mb-2 pa-2"
          @click="load_log_data_1m('6d')"
          >6d
          <v-tooltip activator="parent" location="bottom"
            >6days ago<br />interval : 1 minute</v-tooltip
          >
        </v-btn>
        <v-btn
          size="small"
          class="mt-2 mb-2 pa-2"
          @click="load_log_data_1m('5d')"
          >5d
          <v-tooltip activator="parent" location="bottom"
            >5days ago<br />interval : 1 minute</v-tooltip
          >
        </v-btn>
        <v-btn
          size="small"
          class="mt-2 mb-2 pa-2"
          @click="load_log_data_1m('4d')"
          >4d
          <v-tooltip activator="parent" location="bottom"
            >4days ago<br />interval : 1 minute</v-tooltip
          >
        </v-btn>
        <v-btn
          size="small"
          class="mt-2 mb-2 pa-2"
          @click="load_log_data_1m('3d')"
          >3d
          <v-tooltip activator="parent" location="bottom"
            >3days ago<br />interval : 1 minute</v-tooltip
          >
        </v-btn>
        <v-btn
          size="small"
          class="mt-2 mb-2 pa-2"
          @click="load_log_data_1m('2d')"
          >2d
          <v-tooltip activator="parent" location="bottom"
            >2days ago<br />interval : 1 minute</v-tooltip
          >
        </v-btn>
        <v-btn
          size="small"
          class="mt-2 mb-2 pa-2"
          @click="load_log_data_1m('1d')"
          >1d
          <v-tooltip activator="parent" location="bottom"
            >1days ago<br />interval : 1 minute</v-tooltip
          >
        </v-btn>
        <v-btn
          size="small"
          class="mt-2 mb-2 pa-2"
          :disabled="
            slider_1m_estimated_datacount > limit_time_for_zoomin ||
            slider_1m_estimated_datacount == 0 ||
            show_data_file_title != device_data_title ||
            toggle_zoom != 0
          "
          @click="load_data_1s_dlg = true"
          >1s
          <v-tooltip activator="parent" location="bottom"
            >interval : 1 second</v-tooltip
          >
        </v-btn>
        <v-btn
          size="small"
          class="mt-2 mb-2 pa-2"
          :disabled="
            slider_1s_estimated_datacount > limit_time_for_zoomin_100ms ||
            slider_1s_estimated_datacount == 0 ||
            show_data_file_title != device_data_title ||
            toggle_zoom != 1
          "
          @click="load_data_100ms_dlg = true"
          >100ms
          <v-tooltip activator="parent" location="bottom"
            >interval : 100 ms</v-tooltip
          >
        </v-btn>
        <v-dialog v-model="load_data_1m_dlg" persistent width="50vw">
          <v-card class="pa-5">
            <v-card-title class="text-h5 pb-5"
              >Load LogData from Device</v-card-title
            >
            <v-card-text>
              <v-row justify="center" class="mb-5">
                <v-btn-toggle
                  v-model="toggle_load"
                  class="ml-2"
                  variant="outlined"
                  divided
                  mandatory
                  :disabled="port_disabled"
                >
                  <v-btn
                    size="small"
                    class="mt-2 mb-2 pa-2"
                    @click="set_slider_7d('All')"
                    >All
                  </v-btn>
                  <v-btn
                    size="small"
                    class="mt-2 mb-2 pa-2"
                    @click="set_slider_7d('7d')"
                    >7d
                  </v-btn>
                  <v-btn
                    size="small"
                    class="mt-2 mb-2 pa-2"
                    @click="set_slider_7d('6d')"
                    >6d
                  </v-btn>
                  <v-btn
                    size="small"
                    class="mt-2 mb-2 pa-2"
                    @click="set_slider_7d('5d')"
                    >5d
                  </v-btn>
                  <v-btn
                    size="small"
                    class="mt-2 mb-2 pa-2"
                    @click="set_slider_7d('4d')"
                    >4d
                  </v-btn>
                  <v-btn
                    size="small"
                    class="mt-2 mb-2 pa-2"
                    @click="set_slider_7d('3d')"
                    >3d
                  </v-btn>
                  <v-btn
                    size="small"
                    class="mt-2 mb-2 pa-2"
                    @click="set_slider_7d('2d')"
                    >2d
                  </v-btn>
                  <v-btn
                    size="small"
                    class="mt-2 mb-2 pa-2"
                    @click="set_slider_7d('1d')"
                    >1d
                  </v-btn>
                </v-btn-toggle>
              </v-row>
              <v-row>
                <v-label class="me-auto">{{
                  new Date(modbusStore.log7dMinTime).toISOString()
                }}</v-label>
                <v-label>{{
                  new Date(modbusStore.log7dMaxTime).toISOString()
                }}</v-label>
              </v-row>
              <v-range-slider
                v-model="slider_7d"
                thumb-size="10"
                strict
                class="ma-2"
                hide-details
              ></v-range-slider>
              <v-row justify="center">
                <v-label>{{
                  new Date(slider_7d_timeRange[0]).toISOString()
                }}</v-label
                >&nbsp;~&nbsp;
                <v-label>{{
                  new Date(slider_7d_timeRange[1]).toISOString()
                }}</v-label>
              </v-row>
              <v-row justify="center" class="mt-10 mb-5 text-h5"
                >Expected Information</v-row
              >
              <v-row justify="center">Interval Time : 1 minute</v-row>
              <v-row justify="center"
                >Data Count : {{ slider_7d_estimated_datacount }}</v-row
              >
              <v-row justify="center"
                >Loading Time :
                {{ Math.floor((slider_7d_estimated_datacount * 80) / 10080) }}
                s</v-row
              >
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                variant="text"
                :disabled="
                  slider_7d_estimated_datacount < limit_time_for_zoomin * 2
                "
                @click="startLog1mData"
                >Load</v-btn
              >
              <v-btn
                variant="text"
                @click="
                  () => {
                    load_data_1m_dlg = false;
                  }
                "
                >Cancel</v-btn
              >
            </v-card-actions>
          </v-card>
        </v-dialog>
        <v-dialog v-model="load_data_1s_dlg" persistent width="50vw">
          <v-card class="pa-5">
            <v-card-title class="text-h5"
              >Load LogData from Device</v-card-title
            >
            <v-card-text>
              <v-row justify="center" class="mt-5 mb-5 text-h5"
                >Expected Information</v-row
              >
              <v-row justify="center">
                <v-label>{{
                  new Date(slider_1m_timeRange[0]).toISOString()
                }}</v-label
                >&nbsp;~&nbsp;
                <v-label>{{
                  new Date(slider_1m_timeRange[1]).toISOString()
                }}</v-label>
              </v-row>
              <v-row justify="center">Interval Time : 1 second</v-row>
              <v-row justify="center"
                >Data Count : {{ slider_1m_estimated_datacount * 60 }}</v-row
              >
              <v-row justify="center"
                >Loading Time :
                {{
                  Math.floor((slider_1m_estimated_datacount * 60 * 80) / 10080)
                }}
                s</v-row
              >
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn variant="text" @click="startLog1sData">Load</v-btn>
              <v-btn
                variant="text"
                @click="
                  () => {
                    load_data_1s_dlg = false;
                  }
                "
                >Cancel</v-btn
              >
            </v-card-actions>
          </v-card>
        </v-dialog>
        <v-dialog v-model="load_data_100ms_dlg" persistent width="50vw">
          <v-card class="pa-5">
            <v-card-title class="text-h5"
              >Load LogData from Device</v-card-title
            >
            <v-card-text>
              <v-row justify="center" class="mt-5 mb-5 text-h5"
                >Expected Information</v-row
              >
              <v-row justify="center">
                <v-label>{{
                  new Date(slider_1s_timeRange[0]).toISOString()
                }}</v-label
                >&nbsp;~&nbsp;
                <v-label>{{
                  new Date(slider_1s_timeRange[1]).toISOString()
                }}</v-label>
              </v-row>
              <v-row justify="center">Interval Time : 100 ms</v-row>
              <v-row justify="center"
                >Data Count : {{ slider_1s_estimated_datacount * 10 }}</v-row
              >
              <v-row justify="center"
                >Loading Time :
                {{
                  Math.floor((slider_1s_estimated_datacount * 10 * 80) / 10080)
                }}
                s</v-row
              >
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn variant="text" @click="startLog100msData">Load</v-btn>
              <v-btn
                variant="text"
                @click="
                  () => {
                    load_data_100ms_dlg = false;
                  }
                "
                >Cancel</v-btn
              >
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-btn-toggle>
      <v-overlay
        v-model="overlay_mini"
        class="align-center justify-center loading-overlay"
        persistent
      >
        <v-progress-circular :size="50" color="primary" indeterminate>
        </v-progress-circular>
      </v-overlay>
      <v-btn-toggle
        v-model="toggle_zoom"
        class="ml-10 me-auto"
        variant="outlined"
        divided
        mandatory
      >
        <v-btn
          size="small"
          class="mt-2 mb-2"
          :disabled="modbusStore.log1mDataTime.length == 0"
          @click="
            () => {
              chartUpdateData();
              chartUpdateOption();
              chartRedraw();
            }
          "
        >
          <v-icon>zoom_out_map</v-icon>
          1m
          <v-tooltip activator="parent" location="bottom"
            >Zoom Out<br />Interval : 1 minute</v-tooltip
          >
        </v-btn>
        <v-btn
          size="small"
          class="mt-2 mb-2"
          :disabled="modbusStore.log1sDataTime.length == 0"
          @click="
            () => {
              chartUpdateData();
              chartUpdateOption();
              chartRedraw();
            }
          "
        >
          <v-icon>zoom_in</v-icon>
          1s
          <v-tooltip activator="parent" location="bottom"
            >Zoom In<br />Interval : 1 second</v-tooltip
          >
        </v-btn>
        <v-btn
          size="small"
          class="mt-2 mb-2"
          :disabled="modbusStore.log100msDataTime.length == 0"
          @click="
            () => {
              chartUpdateData();
              chartUpdateOption();
              chartRedraw();
            }
          "
        >
          <v-icon>zoom_in</v-icon>
          100ms
          <v-tooltip activator="parent" location="bottom"
            >Zoom In<br />Interval : 100 ms</v-tooltip
          >
        </v-btn>
      </v-btn-toggle>
      <v-label>{{ show_data_file_title }}</v-label>
      <v-btn
        variant="text"
        :loading="loadingBtnOpen"
        @click="onButtonClickOpen"
      >
        <v-icon>folder_open</v-icon>
        <v-tooltip activator="parent" location="bottom">
          Open data from file
        </v-tooltip>
        <input
          ref="openFile"
          :key="open_file_key"
          class="d-none"
          type="file"
          accept=".eqda"
          @change="onFileOpenChanged"
        />
      </v-btn>
      <v-dialog v-model="save_dialog" persistent width="auto">
        <template #activator="{ props }">
          <v-btn
            v-bind="props"
            variant="text"
            :loading="save_dialog"
            :disabled="
              modbusStore.log1mDataTime.length == 0 ||
              show_data_file_title != device_data_title
            "
            @click="onButtonClickSave"
          >
            <v-icon>save</v-icon>
            <v-tooltip activator="parent"> Save data to file </v-tooltip>
          </v-btn>
        </template>
        <v-card>
          <v-card-title class="text-h5"> Download Chart Data </v-card-title>
          <v-card-text>
            <v-text-field
              v-model="save_file_name"
              :rules="[(v: unknown) => !!v || 'Field is required']"
              label="File name"
              variant="underlined"
              suffix=".eqda"
              :error-messages="save_file_err_msg"
            ></v-text-field>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="green-darken-1"
              variant="text"
              @click="download_save_data"
            >
              Download
            </v-btn>
            <v-btn
              color="green-darken-1"
              variant="text"
              @click="
                () => {
                  save_dialog = false;
                }
              "
            >
              Cancel
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>
    <v-row class="align-center">
      <v-label>( period: 7days )&nbsp;</v-label>
      <v-btn
        icon="keyboard_double_arrow_left"
        variant="text"
        size="x-small"
        disabled
      ></v-btn>
      <v-btn
        icon="navigate_before"
        variant="text"
        size="x-small"
        disabled
      ></v-btn>
      <v-range-slider
        v-model="slider_7d"
        thumb-size="10"
        strict
        hide-details
        disabled
      ></v-range-slider>
      <v-btn
        icon="navigate_next"
        variant="text"
        size="x-small"
        disabled
      ></v-btn>
      <v-btn
        icon="keyboard_double_arrow_right"
        variant="text"
        size="x-small"
        disabled
      ></v-btn>
    </v-row>
    <v-row v-if="modbusStore.log1mDataTime.length > 0" class="align-center">
      <v-label>( interval: 1min )&nbsp;</v-label>
      <v-btn
        icon="keyboard_double_arrow_left"
        variant="text"
        size="x-small"
        :disabled="toggle_zoom != 0 || slider_1m[0] == 0"
        @click="slider_1m_goLeftEnd"
      ></v-btn>
      <v-btn
        icon="navigate_before"
        variant="text"
        size="x-small"
        :disabled="toggle_zoom != 0 || slider_1m[0] == 0"
        @click="slider_1m_goLeftPage"
      ></v-btn>
      <v-range-slider
        v-model="slider_1m"
        thumb-size="10"
        strict
        class="ml-2 mr-2"
        min="0"
        hide-details
        :disabled="toggle_zoom != 0"
      ></v-range-slider>
      <v-btn
        icon="navigate_next"
        variant="text"
        size="x-small"
        :disabled="toggle_zoom != 0 || slider_1m[1] == 100"
        @click="slider_1m_goRightPage"
      ></v-btn>
      <v-btn
        icon="keyboard_double_arrow_right"
        variant="text"
        size="x-small"
        :disabled="toggle_zoom != 0 || slider_1m[1] == 100"
        @click="slider_1m_goRightEnd"
      ></v-btn>
    </v-row>
    <v-row v-if="modbusStore.log1sDataTime.length > 0" class="align-center">
      <v-label>( interval: 1 sec)&nbsp;</v-label>
      <v-btn
        icon="keyboard_double_arrow_left"
        variant="text"
        size="x-small"
        :disabled="toggle_zoom != 1 || slider_1s[0] == 0"
        @click="slider_1s_goLeftEnd"
      ></v-btn>
      <v-btn
        icon="navigate_before"
        variant="text"
        size="x-small"
        :disabled="toggle_zoom != 1 || slider_1s[0] == 0"
        @click="slider_1s_goLeftPage"
      ></v-btn>
      <v-range-slider
        v-model="slider_1s"
        thumb-size="10"
        strict
        class="ml-2 mr-2"
        min="0"
        hide-details
        :disabled="toggle_zoom != 1"
      ></v-range-slider>
      <v-btn
        icon="navigate_next"
        variant="text"
        size="x-small"
        :disabled="toggle_zoom != 1 || slider_1s[1] == 100"
        @click="slider_1s_goRightPage"
      ></v-btn>
      <v-btn
        icon="keyboard_double_arrow_right"
        variant="text"
        size="x-small"
        :disabled="toggle_zoom != 1 || slider_1s[1] == 100"
        @click="slider_1s_goRightEnd"
      ></v-btn>
    </v-row>
    <v-row v-if="modbusStore.log100msDataTime.length > 0" class="align-center">
      <v-label>( interval:100ms)</v-label>
      <v-btn
        icon="keyboard_double_arrow_left"
        variant="text"
        size="x-small"
        :disabled="toggle_zoom != 2 || slider_100ms[0] == 0"
        @click="slider_100ms_goLeftEnd"
      ></v-btn>
      <v-btn
        icon="navigate_before"
        variant="text"
        size="x-small"
        :disabled="toggle_zoom != 2 || slider_100ms[0] == 0"
        @click="slider_100ms_goLeftPage"
      ></v-btn>
      <v-range-slider
        v-model="slider_100ms"
        thumb-size="10"
        strict
        class="ml-2 mr-2"
        min="0"
        hide-details
        :disabled="toggle_zoom != 2"
      ></v-range-slider>
      <v-btn
        icon="navigate_next"
        variant="text"
        size="x-small"
        :disabled="toggle_zoom != 2 || slider_100ms[1] == 100"
        @click="slider_100ms_goRightPage"
      ></v-btn>
      <v-btn
        icon="keyboard_double_arrow_right"
        variant="text"
        size="x-small"
        :disabled="toggle_zoom != 2 || slider_100ms[1] == 100"
        @click="slider_100ms_goRightEnd"
      ></v-btn>
    </v-row>
    <v-row>
      <canvas
        id="chart_history"
        class="chart_canvas pt-0 mt-0"
        style="height: 60vh; position: relative"
        @contextmenu="onContextMenu"
        @wheel="onMouseScroll"
        @mousedown="onMouseDown"
        @mouseup="onMouseUp"
        @mousemove="onMouseMove"
      >
      </canvas>
      <v-overlay
        v-model="overlay"
        class="align-center justify-center loading-overlay"
        persistent
      >
        <v-progress-circular
          :size="100"
          :width="10"
          :model-value="progress_value"
          color="success"
        >
          {{ Math.floor(progress_value) }} %
        </v-progress-circular>
      </v-overlay>
      <v-menu
        v-model="showContextMenu"
        :close-on-content-click="false"
        :style="contextStyle"
        @mouseleave="showContextMenu = false"
      >
        <v-card>
          <v-card-text>
            <v-list>
              <v-list-subheader>Display Options</v-list-subheader>
              <v-list-item>
                <v-switch
                  v-model="showDots"
                  label="Dots enabled"
                  color="primary"
                  class="ml-5"
                />
              </v-list-item>

              <v-divider />
              <v-list-subheader>Scaling Options</v-list-subheader>
              <v-list-item>
                <v-switch
                  v-model="autoscaling"
                  label="Automatic scaling"
                  color="primary"
                  hide-details
                  class="ml-5"
                ></v-switch>
              </v-list-item>
              <template v-if="!autoscaling">
                <v-list-item>
                  <v-text-field
                    v-if="!autoscaling"
                    v-model="min_y"
                    label="Min.Y"
                    type="number"
                    inputmode="numeric"
                    variant="underlined"
                    :error-messages="error_msg_min"
                    class="ml-5"
                  ></v-text-field>
                </v-list-item>
                <v-list-item>
                  <v-text-field
                    v-if="!autoscaling"
                    v-model="max_y"
                    label="Max.Y"
                    type="number"
                    inputmode="numeric"
                    variant="underlined"
                    :error-messages="error_msg_max"
                    class="ml-5"
                  ></v-text-field>
                </v-list-item>
              </template>
            </v-list>
          </v-card-text>
        </v-card>
      </v-menu>
    </v-row>
    <v-row v-if="toggle_zoom == 0">
      <v-label class="me-auto">{{
        new Date(slider_1m_timeRange[0]).toISOString()
      }}</v-label>
      <v-label>{{ new Date(slider_1m_timeRange[1]).toISOString() }}</v-label>
    </v-row>
    <v-row v-if="toggle_zoom == 1">
      <v-label class="me-auto">{{
        new Date(slider_1s_timeRange[0]).toISOString()
      }}</v-label>
      <v-label>{{ new Date(slider_1s_timeRange[1]).toISOString() }}</v-label>
    </v-row>
  </div>
</template>

<script setup lang="ts">
import { ref, computed, onMounted, watch } from "vue";
import { useTheme } from "vuetify";
import {
  millisecondsInSecond,
  millisecondsInMinute,
  millisecondsInHour,
} from "date-fns/constants";
import Chart, { TimeUnit } from "chart.js/auto";
import "chartjs-adapter-date-fns";
import { saveAs } from "file-saver";
import { PortState } from "@/enums/PortState";
import { useByteUtils } from "@/composables/useByteUtils";
import { useDelay } from "@/composables/useDelay";
import { useModbusAddress } from "@/composables/useModbusAddress";
import { useStorage } from "@/composables/useStorage";
import { useUtils } from "@/composables/useUtils";
import { useModbusStore } from "@/stores/useModbusStore";

const { bytes_to_date_time, uint16_to_bytes } = useByteUtils();
const { delay } = useDelay();
const { modbusAddress } = useModbusAddress();
const modbusStore = useModbusStore();
const theme = useTheme();
const { isCanvas } = useUtils();
const { showDotsKey, autoscalingKey, minYKey, maxYKey } =
  useStorage("history_page");

const millisecondsInDay = 24 * millisecondsInHour; // 1 d
const slide_limit_time_1m = 10 * millisecondsInMinute; // 10 min
const slide_limit_time_1s = 30 * millisecondsInSecond; // 30 s
const slide_limit_time_100ms = 30 * 100; // 30  * 100ms
const limit_time_for_zoomin = 100; //count
const limit_time_for_zoomin_100ms = 100; //count

const dark_grid_color = "#404040";
const light_grid_color = "#f0f0f0";

const port_disabled = computed(
  () => modbusStore.portState === PortState.disconnected,
);

const showDots = ref(true);
const autoscaling = ref(true);

const UNDER_CONSTRUCTION = ref(true);

watch(showDots, (newVal) => {
  localStorage.setItem(showDotsKey.value, String(newVal));
  chartUpdateOption();
  chartRedraw();
});

watch(autoscaling, (newVal) => {
  localStorage.setItem(autoscalingKey.value, String(newVal));
  chartUpdateOption();
  chartRedraw();
});

const error_msg_min = ref("");
const min_y = ref(0);
watch(min_y, (newVal) => {
  if (!newVal) {
    error_msg_min.value = "Please enter value";
  } else if (newVal >= max_y.value) {
    error_msg_min.value = "Must be MinY < MaxY";
  } else {
    localStorage.setItem(minYKey.value, newVal.toString());
    error_msg_min.value = "";
  }
  chartUpdateOption();
  chartRedraw();
});

const error_msg_max = ref("");
const max_y = ref(100);
watch(max_y, (newVal) => {
  if (!newVal) {
    error_msg_max.value = "Please enter value";
  } else if (min_y.value >= newVal) {
    error_msg_max.value = "Must be MinY < MaxY";
  } else {
    localStorage.setItem(maxYKey.value, newVal.toString());
    error_msg_max.value = "";
  }
  chartUpdateOption();
  chartRedraw();
});

//--------- chart --------------------------
let chart_obj: Chart<"line">;
let ctx;
function chartUpdateData() {
  for (let j = 0; j < 8; j++) {
    chart_obj.data.datasets[j].spanGaps = false;
  }
  if (toggle_zoom.value == 0) {
    if (modbusStore.log1mDataTime.length > 0) {
      const len = modbusStore.log1mDataTime.length;
      const dt_array: string[] = [];
      for (let i = 0; i < len; i++) {
        dt_array.push(new Date(modbusStore.log1mDataTime[i]).toISOString());
      }
      chart_obj.data.labels = dt_array;
      chart_obj.data.datasets[0].data = modbusStore.log1mDataRP;
      chart_obj.data.datasets[1].data = modbusStore.log1mDataS1;
      chart_obj.data.datasets[2].data = modbusStore.log1mDataS2;
      chart_obj.data.datasets[3].data = modbusStore.log1mDataM12;
      chart_obj.data.datasets[4].data = modbusStore.log1mDataSetpoint;
      chart_obj.data.datasets[5].data = modbusStore.log1mDataV1;
      chart_obj.data.datasets[6].data = modbusStore.log1mDataV2;
      chart_obj.data.datasets[7].data = modbusStore.log1mDataTemp;
    } else {
      chart_obj.data.labels = [];
      chart_obj.data.datasets.forEach((item) => {
        item.data = [];
      });
    }
  } else if (toggle_zoom.value == 1) {
    if (modbusStore.log1sDataTime.length > 0) {
      const len = modbusStore.log1sDataTime.length;
      const dt_array: string[] = [];
      for (let i = 0; i < len; i++) {
        dt_array.push(new Date(modbusStore.log1sDataTime[i]).toISOString());
      }
      chart_obj.data.labels = dt_array;
      chart_obj.data.datasets[0].data = modbusStore.log1sDataRP;
      chart_obj.data.datasets[1].data = modbusStore.log1sDataS1;
      chart_obj.data.datasets[2].data = modbusStore.log1sDataS2;
      chart_obj.data.datasets[3].data = modbusStore.log1sDataM12;
      chart_obj.data.datasets[4].data = modbusStore.log1sDataSetpoint;
      chart_obj.data.datasets[5].data = modbusStore.log1sDataV1;
      chart_obj.data.datasets[6].data = modbusStore.log1sDataV2;
      chart_obj.data.datasets[7].data = modbusStore.log1sDataTemp;
    } else {
      chart_obj.data.labels = [];
      chart_obj.data.datasets.forEach((item) => {
        item.data = [];
      });
    }
  } else if (toggle_zoom.value == 2) {
    if (modbusStore.log100msDataTime.length > 0) {
      const len = modbusStore.log100msDataTime.length;
      const dt_array: string[] = [];
      for (let i = 0; i < len; i++) {
        dt_array.push(new Date(modbusStore.log100msDataTime[i]).toISOString());
      }
      chart_obj.data.labels = dt_array;
      chart_obj.data.datasets[0].data = modbusStore.log100msDataRP;
      chart_obj.data.datasets[1].data = modbusStore.log100msDataS1;
      chart_obj.data.datasets[2].data = modbusStore.log100msDataS2;
      chart_obj.data.datasets[3].data = modbusStore.log100msDataM12;
      chart_obj.data.datasets[4].data = modbusStore.log100msDataSetpoint;
      chart_obj.data.datasets[5].data = modbusStore.log100msDataV1;
      chart_obj.data.datasets[6].data = modbusStore.log100msDataV2;
      chart_obj.data.datasets[7].data = modbusStore.log100msDataTemp;
    } else {
      chart_obj.data.labels = [];
      chart_obj.data.datasets.forEach((item) => {
        item.data = [];
      });
    }
  }
}
function chartUpdateOption() {
  const pointRadius = showDots.value ? 2 : 0;
  const min_val = autoscaling.value ? undefined : +min_y.value;
  const max_val = autoscaling.value ? undefined : +max_y.value;

  let timestamp_range = 0;
  //------- Set Time Range -------------
  let min_time = new Date().toISOString();
  let max_time = new Date().toISOString();
  if (toggle_zoom.value == 0) {
    //"minute"
    const min_timestamp =
      ((slider_7d_timeRange.value[1] - slider_7d_timeRange.value[0]) *
        slider_1m.value[0]) /
        100 +
      slider_7d_timeRange.value[0];
    const max_timestamp =
      ((slider_7d_timeRange.value[1] - slider_7d_timeRange.value[0]) *
        slider_1m.value[1]) /
        100 +
      slider_7d_timeRange.value[0];
    timestamp_range = max_timestamp - min_timestamp;
    min_time = new Date(min_timestamp).toISOString();
    max_time = new Date(max_timestamp).toISOString();
  } else if (toggle_zoom.value == 1) {
    //"second"
    const min_timestamp =
      ((slider_1m_timeRange.value[1] - slider_1m_timeRange.value[0]) *
        slider_1s.value[0]) /
        100 +
      slider_1m_timeRange.value[0];
    const max_timestamp =
      ((slider_1m_timeRange.value[1] - slider_1m_timeRange.value[0]) *
        slider_1s.value[1]) /
        100 +
      slider_1m_timeRange.value[0];
    timestamp_range = max_timestamp - min_timestamp;
    min_time = new Date(min_timestamp).toISOString();
    max_time = new Date(max_timestamp).toISOString();
  } else if (toggle_zoom.value == 2) {
    //"100ms"
    const min_timestamp =
      ((slider_1s_timeRange.value[1] - slider_1s_timeRange.value[0]) *
        slider_100ms.value[0]) /
        100 +
      slider_1s_timeRange.value[0];
    const max_timestamp =
      ((slider_1s_timeRange.value[1] - slider_1s_timeRange.value[0]) *
        slider_100ms.value[1]) /
        100 +
      slider_1s_timeRange.value[0];
    timestamp_range = max_timestamp - min_timestamp;
    min_time = new Date(min_timestamp).toISOString();
    max_time = new Date(max_timestamp).toISOString();
  }

  //------ Set Time Unit -------------------
  let time_unit = "second" as TimeUnit;
  if (timestamp_range > 2 * millisecondsInDay) {
    time_unit = "day";
  } else if (timestamp_range > 3 * millisecondsInHour) {
    time_unit = "hour";
  } else if (timestamp_range > 3 * millisecondsInMinute) {
    time_unit = "minute";
  } else {
    time_unit = "second";
  }

  chart_obj.options = {
    plugins: {
      legend: {
        display: true,
      },
    },
    responsive: true,
    animation: false,
    maintainAspectRatio: false,
    elements: {
      point: {
        radius: pointRadius,
      },
      line: {
        tension: 0,
      },
    },
    scales: {
      x: {
        type: "time",
        min: min_time,
        max: max_time,
        time: {
          unit: time_unit,
        },
        grid: {
          color: theme.global.current.value.dark
            ? dark_grid_color
            : light_grid_color,
          lineWidth: 1,
        },
      },
      y: {
        display: true,
        position: "left",
        min: min_val,
        max: max_val,
        grid: {
          color: theme.global.current.value.dark
            ? dark_grid_color
            : light_grid_color,
          lineWidth: 1,
        },
      },
    },
  };
}
function chartRedraw() {
  chart_obj.update();
}
function chartInit() {
  ctx = document.getElementById("chart_history");
  if (!isCanvas(ctx)) {
    return;
  }
  chart_element.value = ctx;
  const maxTime = new Date();
  const timespan =
    localStorage.getItem(
      "history_page" + modbusStore.portIndex.toString() + "//timespan",
    ) ?? "10";
  const minTime = new Date(
    new Date().getTime() - parseInt(timespan) * millisecondsInSecond,
  );
  chart_obj = new Chart(ctx, {
    type: "line",
    data: {
      datasets: [
        {
          label: "Controlled Pressure",
          data: [],
          borderWidth: 1,
          borderColor: "#eb5b0d",
          backgroundColor: "#eb5b0d",
        },
        {
          label: "Input-A",
          data: [],
          borderWidth: 1,
          borderColor: "#192ae4",
          backgroundColor: "#192ae4",
        },
        {
          label: "Input-B",
          data: [],
          borderWidth: 1,
          borderColor: "#466aa5",
          backgroundColor: "#466aa5",
        },
        {
          label: "Input-C",
          data: [],
          borderWidth: 1,
          borderColor: "#004d40",
          backgroundColor: "#004d40",
        },
        {
          label: "Setpoint",
          data: [],
          borderWidth: 1,
          borderColor: "#1b5e20",
          backgroundColor: "#1b5e20",
        },
        {
          label: "Intake Valve",
          data: [],
          borderWidth: 1,
          borderColor: "#827717",
          backgroundColor: "#827717",
        },
        {
          label: "Exhaust Valve",
          data: [],
          borderWidth: 1,
          borderColor: "#311b92",
          backgroundColor: "#311b92",
        },
        {
          label: "Temperature",
          data: [],
          borderWidth: 1,
          borderColor: "#b71c1c",
          backgroundColor: "#b71c1c",
        },
      ],
    },
    options: {
      plugins: {
        legend: {
          display: true,
        },
      },
      responsive: true,
      animation: false,
      maintainAspectRatio: false,
      scales: {
        x: {
          type: "time",
          min: minTime.toISOString(),
          max: maxTime.toISOString(),
          time: {
            unit: "minute",
            displayFormats: {
              quarter: "MM dd",
            },
          },
          grid: {
            color: theme.global.current.value.dark
              ? dark_grid_color
              : light_grid_color,
            lineWidth: 1,
          },
        },
        y: {
          type: "linear",
          display: true,
          position: "left",
          grid: {
            color: theme.global.current.value.dark
              ? dark_grid_color
              : light_grid_color,
            lineWidth: 1,
          },
        },
      },
    },
  });
}
//----------------------------------------------------------------------------
onMounted(() => {
  if (modbusStore.slider_7d[0] + modbusStore.slider_7d[1] > 0) {
    slider_7d.value = modbusStore.slider_7d;
  }
  if (modbusStore.slider_1m[0] + modbusStore.slider_1m[1] > 0) {
    slider_1m.value = modbusStore.slider_1m;
  }
  if (modbusStore.slider_1s[0] + modbusStore.slider_1s[1] > 0) {
    slider_1s.value = modbusStore.slider_1s;
  }
  if (modbusStore.slider_100ms[0] + modbusStore.slider_100ms[1] > 0) {
    slider_100ms.value = modbusStore.slider_100ms;
  }
  toggle_zoom.value = modbusStore.logToggleZoom;
  // show_data_file_title.value = modbusStore.show_data_file_title;

  getChartSettings();
  chartInit();
  chartUpdateData();
  chartUpdateOption();
  chartRedraw();
});

const chart_element = ref();
let chart_width = 1;
function getChartSize() {
  const rect = chart_element.value?.getBoundingClientRect();
  chart_width = rect ? rect?.right - rect?.left : 1;
}

//-------------- Context Menu --------------------
const showContextMenu = ref(false);
watch(showContextMenu, () => {
  getChartSettings();
});
const contextMenuX = ref(0);
const contextMenuY = ref(0);

const contextStyle = computed(() => {
  return (
    "position: absolute; z-index: 500; left: " +
    contextMenuX.value.toString() +
    "px; top: " +
    contextMenuY.value.toString() +
    "px;"
  );
});

function onContextMenu(e: MouseEvent): void {
  e.preventDefault();
  contextMenuX.value = e.clientX;
  contextMenuY.value = e.clientY;
  showContextMenu.value = true;
}

function getChartSettings() {
  showDots.value = localStorage.getItem(showDotsKey.value) === "true";
  autoscaling.value = localStorage.getItem(autoscalingKey.value) === "true";

  //--------- Min Y ------------
  if (
    !(
      "history_page" +
        modbusStore.portIndex.toString() +
        "//settings-" +
        "min_y" in
      localStorage
    )
  ) {
    localStorage.setItem(
      "history_page" +
        modbusStore.portIndex.toString() +
        "//settings-" +
        "min_y",
      "0",
    );
    min_y.value = 0;
  } else {
    min_y.value = parseFloat(
      localStorage.getItem(
        "history_page" +
          modbusStore.portIndex.toString() +
          "//settings-" +
          "min_y",
      ) ?? "0",
    );
  }
  //--------- Max Y ------------
  if (
    !(
      "history_page" +
        modbusStore.portIndex.toString() +
        "//settings-" +
        "max_y" in
      localStorage
    )
  ) {
    localStorage.setItem(
      "history_page" +
        modbusStore.portIndex.toString() +
        "//settings-" +
        "max_y",
      "100",
    );
    max_y.value = 100;
  } else {
    max_y.value = parseFloat(
      localStorage.getItem(
        "history_page" +
          modbusStore.portIndex.toString() +
          "//settings-" +
          "max_y",
      ) ?? "100",
    );
  }
}
//--------------------------------------------------------
const toggle_zoom = ref();
watch(toggle_zoom, (newVal) => {
  modbusStore.logToggleZoom = newVal;
});
const toggle_load = ref();
//----------------------------------------------------------------
const slider_7d = ref([0, 100]);
const slider_1m = ref([0, 100]);
const slider_1s = ref([0, 100]);
const slider_100ms = ref([0, 100]);

const slider_7d_0 = computed(() => {
  return slider_7d.value[0];
});
const slider_7d_1 = computed(() => {
  return slider_7d.value[1];
});
watch(slider_7d_0, (newVal) => {
  const slide_alltime = modbusStore.log7dMaxTime - modbusStore.log7dMinTime;
  if (
    (slide_alltime * (slider_7d_1.value - newVal)) / 100 <
    limit_time_for_zoomin * 2 * 60 * millisecondsInSecond
  ) {
    const range =
      (100 * limit_time_for_zoomin * 2 * 60 * millisecondsInSecond) /
      slide_alltime;
    slider_7d.value[0] = slider_7d_1.value - range;
  }
  modbusStore.slider_7d[0] = slider_7d.value[0];
});
watch(slider_7d_1, (newVal) => {
  const slide_alltime = modbusStore.log7dMaxTime - modbusStore.log7dMinTime;
  if (
    (slide_alltime * (newVal - slider_7d_0.value)) / 100 <
    limit_time_for_zoomin * 2 * 60 * millisecondsInSecond
  ) {
    const range =
      (100 * limit_time_for_zoomin * 2 * 60 * millisecondsInSecond) /
      slide_alltime;
    slider_7d.value[1] = slider_7d_0.value + range;
  }
  modbusStore.slider_7d[1] = slider_7d.value[1];
});

const slider_1m_0 = computed(() => {
  return slider_1m.value[0];
});
const slider_1m_1 = computed(() => {
  return slider_1m.value[1];
});
watch(slider_1m_0, (newVal) => {
  const slide_alltime =
    slider_7d_timeRange.value[1] - slider_7d_timeRange.value[0];
  if (
    (slide_alltime * (slider_1m_1.value - newVal)) / 100 <
    slide_limit_time_1m
  ) {
    const range = (100 * slide_limit_time_1m) / slide_alltime;
    slider_1m.value[0] = slider_1m_1.value - range;
  }
  modbusStore.slider_1m[0] = slider_1m.value[0];
  chartUpdateOption();
  chartRedraw();
});
watch(slider_1m_1, (newVal) => {
  const slide_alltime =
    slider_7d_timeRange.value[1] - slider_7d_timeRange.value[0];
  if (
    (slide_alltime * (newVal - slider_1m_0.value)) / 100 <
    slide_limit_time_1m
  ) {
    const range = (100 * slide_limit_time_1m) / slide_alltime;
    slider_1m.value[1] = slider_1m_0.value + range;
  }
  modbusStore.slider_1m[1] = slider_1m.value[1];
  chartUpdateOption();
  chartRedraw();
});

const slider_1s_0 = computed(() => {
  return slider_1s.value[0];
});
const slider_1s_1 = computed(() => {
  return slider_1s.value[1];
});
watch(slider_1s_0, (newVal) => {
  const slide_alltime =
    slider_1m_timeRange.value[1] - slider_1m_timeRange.value[0];
  if (
    (slide_alltime * (slider_1s_1.value - newVal)) / 100 <
    slide_limit_time_1s
  ) {
    const range = (100 * slide_limit_time_1s) / slide_alltime;
    slider_1s.value[0] = slider_1s_1.value - range;
  }
  modbusStore.slider_1s[0] = slider_1s.value[0];
  chartUpdateOption();
  chartRedraw();
});
watch(slider_1s_1, (newVal) => {
  const slide_alltime =
    slider_1m_timeRange.value[1] - slider_1m_timeRange.value[0];
  if (
    (slide_alltime * (newVal - slider_1s_0.value)) / 100 <
    slide_limit_time_1s
  ) {
    const range = (100 * slide_limit_time_1s) / slide_alltime;
    slider_1s.value[1] = slider_1s_0.value + range;
  }
  modbusStore.slider_1s[1] = slider_1s.value[1];
  chartUpdateOption();
  chartRedraw();
});

const slider_100ms_0 = computed(() => {
  return slider_100ms.value[0];
});
const slider_100ms_1 = computed(() => {
  return slider_100ms.value[1];
});
watch(slider_100ms_0, (newVal) => {
  const slide_alltime =
    slider_1s_timeRange.value[1] - slider_1s_timeRange.value[0];
  if (
    (slide_alltime * (slider_100ms_1.value - newVal)) / 100 <
    slide_limit_time_100ms
  ) {
    const range = (100 * slide_limit_time_100ms) / slide_alltime;
    slider_100ms.value[0] = slider_100ms_1.value - range;
  }
  modbusStore.slider_100ms[0] = slider_100ms.value[0];
  chartUpdateOption();
  chartRedraw();
});
watch(slider_100ms_1, (newVal) => {
  const slide_alltime =
    slider_1s_timeRange.value[1] - slider_1s_timeRange.value[0];
  if (
    (slide_alltime * (newVal - slider_100ms_0.value)) / 100 <
    slide_limit_time_100ms
  ) {
    const range = (100 * slide_limit_time_100ms) / slide_alltime;
    slider_100ms.value[1] = slider_100ms_0.value + range;
  }
  modbusStore.slider_100ms[1] = slider_100ms.value[1];
  chartUpdateOption();
  chartRedraw();
});
//----------------------------------------------------------------------
function slider_1m_goLeftEnd() {
  const slider_1m_range = slider_1m.value[1] - slider_1m.value[0];
  slider_1m.value[0] = 0;
  slider_1m.value[1] = slider_1m_range;
  chartUpdateOption();
  chartRedraw();
}
function slider_1m_goRightEnd() {
  const slider_1m_range = slider_1m.value[1] - slider_1m.value[0];
  slider_1m.value[1] = 100;
  slider_1m.value[0] = 100 - slider_1m_range;
  chartUpdateOption();
  chartRedraw();
}
function slider_1m_goLeftPage() {
  const slider_1m_range = slider_1m.value[1] - slider_1m.value[0];
  if (slider_1m.value[0] - slider_1m_range < 0) {
    slider_1m.value[0] = 0;
    slider_1m.value[1] = slider_1m_range;
  } else {
    slider_1m.value[0] = slider_1m.value[0] - slider_1m_range;
    slider_1m.value[1] = slider_1m.value[1] - slider_1m_range;
  }
  chartUpdateOption();
  chartRedraw();
}
function slider_1m_goRightPage() {
  const slider_1m_range = slider_1m.value[1] - slider_1m.value[0];
  if (slider_1m.value[1] + slider_1m_range > 100) {
    slider_1m.value[1] = 100;
    slider_1m.value[0] = 100 - slider_1m_range;
  } else {
    slider_1m.value[0] = slider_1m.value[0] + slider_1m_range;
    slider_1m.value[1] = slider_1m.value[1] + slider_1m_range;
  }
  chartUpdateOption();
  chartRedraw();
}

function slider_1s_goLeftEnd() {
  const slider_1s_range = slider_1s.value[1] - slider_1s.value[0];
  slider_1s.value[0] = 0;
  slider_1s.value[1] = slider_1s_range;
  chartUpdateOption();
  chartRedraw();
}
function slider_1s_goRightEnd() {
  const slider_1s_range = slider_1s.value[1] - slider_1s.value[0];
  slider_1s.value[1] = 100;
  slider_1s.value[0] = 100 - slider_1s_range;
  chartUpdateOption();
  chartRedraw();
}
function slider_1s_goLeftPage() {
  const slider_1s_range = slider_1s.value[1] - slider_1s.value[0];
  if (slider_1s.value[0] - slider_1s_range < 0) {
    slider_1s.value[0] = 0;
    slider_1s.value[1] = slider_1s_range;
  } else {
    slider_1s.value[0] = slider_1s.value[0] - slider_1s_range;
    slider_1s.value[1] = slider_1s.value[1] - slider_1s_range;
  }
  chartUpdateOption();
  chartRedraw();
}
function slider_1s_goRightPage() {
  const slider_1s_range = slider_1s.value[1] - slider_1s.value[0];
  if (slider_1s.value[1] + slider_1s_range > 100) {
    slider_1s.value[1] = 100;
    slider_1s.value[0] = 100 - slider_1s_range;
  } else {
    slider_1s.value[0] = slider_1s.value[0] + slider_1s_range;
    slider_1s.value[1] = slider_1s.value[1] + slider_1s_range;
  }
  chartUpdateOption();
  chartRedraw();
}

function slider_100ms_goLeftEnd() {
  const slider_100ms_range = slider_100ms.value[1] - slider_100ms.value[0];
  slider_100ms.value[0] = 0;
  slider_100ms.value[1] = slider_100ms_range;
  chartUpdateOption();
  chartRedraw();
}
function slider_100ms_goRightEnd() {
  const slider_100ms_range = slider_100ms.value[1] - slider_100ms.value[0];
  slider_100ms.value[1] = 100;
  slider_100ms.value[0] = 100 - slider_100ms_range;
  chartUpdateOption();
  chartRedraw();
}
function slider_100ms_goLeftPage() {
  const slider_100ms_range = slider_100ms.value[1] - slider_100ms.value[0];
  if (slider_100ms.value[0] - slider_100ms_range < 0) {
    slider_100ms.value[0] = 0;
    slider_100ms.value[1] = slider_100ms_range;
  } else {
    slider_100ms.value[0] = slider_100ms.value[0] - slider_100ms_range;
    slider_100ms.value[1] = slider_100ms.value[1] - slider_100ms_range;
  }
  chartUpdateOption();
  chartRedraw();
}
function slider_100ms_goRightPage() {
  const slider_100ms_range = slider_100ms.value[1] - slider_100ms.value[0];
  if (slider_100ms.value[1] + slider_100ms_range > 100) {
    slider_100ms.value[1] = 100;
    slider_100ms.value[0] = 100 - slider_100ms_range;
  } else {
    slider_100ms.value[0] = slider_100ms.value[0] + slider_100ms_range;
    slider_100ms.value[1] = slider_100ms.value[1] + slider_100ms_range;
  }
  chartUpdateOption();
  chartRedraw();
}
//--------------------------------------------------------------
const slider_7d_timeRange = computed(() => {
  const time_7d = modbusStore.log7dMaxTime - modbusStore.log7dMinTime;
  return [
    modbusStore.log7dMinTime + (time_7d * slider_7d.value[0]) / 100,
    modbusStore.log7dMinTime + (time_7d * slider_7d.value[1]) / 100,
  ];
});
const slider_7d_estimated_datacount = computed(() => {
  return Math.floor(
    (slider_7d_timeRange.value[1] - slider_7d_timeRange.value[0]) /
      (60 * millisecondsInSecond),
  );
});
const slider_1m_timeRange = computed(() => {
  const time_1m = slider_7d_timeRange.value[1] - slider_7d_timeRange.value[0];
  return [
    slider_7d_timeRange.value[0] + (time_1m * slider_1m.value[0]) / 100,
    slider_7d_timeRange.value[0] + (time_1m * slider_1m.value[1]) / 100,
  ];
});
const slider_1m_estimated_datacount = computed(() => {
  return Math.floor(
    (slider_1m_timeRange.value[1] - slider_1m_timeRange.value[0]) /
      (60 * millisecondsInSecond),
  );
});
const slider_1s_timeRange = computed(() => {
  const time_1s = slider_1m_timeRange.value[1] - slider_1m_timeRange.value[0];
  return [
    slider_1m_timeRange.value[0] + (time_1s * slider_1s.value[0]) / 100,
    slider_1m_timeRange.value[0] + (time_1s * slider_1s.value[1]) / 100,
  ];
});
const slider_1s_estimated_datacount = computed(() => {
  return Math.floor(
    (slider_1s_timeRange.value[1] - slider_1s_timeRange.value[0]) /
      millisecondsInSecond,
  );
});
//-------------------------------------------------------------------------
function set_slider_7d(
  param: "All" | "7d" | "6d" | "5d" | "4d" | "3d" | "2d" | "1d",
) {
  switch (param) {
    case "All":
      slider_7d.value = [0, 100];
      break;
    case "7d":
      slider_7d.value = [0, 100 / 7];
      break;
    case "6d":
      slider_7d.value = [100 / 7, (100 / 7) * 2];
      break;
    case "5d":
      slider_7d.value = [(100 / 7) * 2, (100 / 7) * 3];
      break;
    case "4d":
      slider_7d.value = [(100 / 7) * 3, (100 / 7) * 4];
      break;
    case "3d":
      slider_7d.value = [(100 / 7) * 4, (100 / 7) * 5];
      break;
    case "2d":
      slider_7d.value = [(100 / 7) * 5, (100 / 7) * 6];
      break;
    case "1d":
      slider_7d.value = [(100 / 7) * 6, 100];
      break;
  }
}
//----------------------------------------------------------------
const overlay = ref(false);
const overlay_mini = ref(false);
const progress_value = ref(0);

const load_data_1m_dlg = ref(false);
const load_data_1s_dlg = ref(false);
const load_data_100ms_dlg = ref(false);

async function load_log_data_1m(
  param: "All" | "7d" | "6d" | "5d" | "4d" | "3d" | "2d" | "1d",
) {
  overlay_mini.value = true;
  modbusStore.modbusRead(modbusStore.deviceAddress, 5020, 2);
  modbusStore.modbusRead(modbusStore.deviceAddress, 5020, 2);
  modbusStore.modbusRead(modbusStore.deviceAddress, 5020, 2);
  //--- getLogDate start -------
  modbusStore.logDateState = 0;
  modbusStore.getLogDate();

  let flag = true;
  const read_logDate = setTimeout(async () => {
    alert("Communication error with device!\nPlease check the device.");
    flag = false;
  }, 100000);
  while (modbusStore.logDateState < 7 && flag) {
    await delay(1);
  }
  if (flag) {
    clearTimeout(read_logDate);
  }
  if (modbusStore.logDateState == 7) {
    const logDateAddress = modbusAddress.logDate;
    let maxTime = 0;
    let minTime = 1e20;
    for (let i = 0; i < 7; i++) {
      if (
        modbusStore.modbusValues[logDateAddress + i * 2] +
          modbusStore.modbusValues[logDateAddress + i * 2 + 1] >
        0
      ) {
        const bytes0 = uint16_to_bytes(
          modbusStore.modbusValues[logDateAddress + i * 2],
        );
        const bytes1 = uint16_to_bytes(
          modbusStore.modbusValues[logDateAddress + i * 2 + 1],
        );
        const dt_bytes = [bytes0[0], bytes0[1], bytes1[0], bytes1[1], 0, 0];
        const log_date = bytes_to_date_time(dt_bytes);
        const log_stamp = log_date.getTime();
        if (log_stamp > maxTime) {
          maxTime = log_stamp;
        }
        if (log_stamp < minTime) {
          minTime = log_stamp;
        }
      }
    }
    modbusStore.log7dMaxTime = maxTime + 24 * 60 * 60 * millisecondsInSecond;
    modbusStore.log7dMinTime =
      modbusStore.log7dMaxTime - 7 * 24 * 60 * 60 * millisecondsInSecond;
    load_data_1m_dlg.value = true;

    set_slider_7d(param);
  }
  overlay_mini.value = false;
}
function startLog1mData() {
  load_data_1m_dlg.value = false;
  //------- Start Log1mData ------------
  modbusStore.clearLog1mData();
  modbusStore.clearLog1sData();
  modbusStore.clearLog100msData();
  slider_1m.value = [0, 100];
  slider_1s.value = [0, 100];
  isEndOfMsg1m = false;
  overlay.value = true;

  dt_start1m = slider_7d_timeRange.value[0];
  dt_end1m = slider_7d_timeRange.value[0] + 5 * millisecondsInMinute;
  if (dt_end1m >= slider_7d_timeRange.value[1]) {
    dt_end1m = slider_7d_timeRange.value[1];
    isEndOfMsg1m = true;
  }
  progress_value.value = 0;
  pack1m_cnt = 0;
  log1m_reload_cnt = 0;
  modbusStore.readLog1mData(modbusStore.deviceAddress, dt_start1m, dt_end1m);
}

let isEndOfMsg1m = false;
let pack1m_cnt = 0;
let log1m_reload_cnt = 0;
let dt_start1m = 0;
let dt_end1m = 0;
const log1mDataBusy = computed(() => {
  return modbusStore.log1mDataBusy;
});
watch(log1mDataBusy, (newVal) => {
  if (!newVal) {
    if (
      modbusStore.log1mDataIsOk ||
      log1m_reload_cnt == modbusStore.maxReloadCount
    ) {
      if (log1m_reload_cnt == modbusStore.maxReloadCount) {
        modbusStore.log1mDataTime.push(dt_start1m);
        modbusStore.log1mDataRP.push(null);
        modbusStore.log1mDataS1.push(null);
        modbusStore.log1mDataS2.push(null);
        modbusStore.log1mDataM12.push(null);
        modbusStore.log1mDataSetpoint.push(null);
        modbusStore.log1mDataV1.push(null);
        modbusStore.log1mDataV2.push(null);
        modbusStore.log1mDataTemp.push(null);
      }
      if (!isEndOfMsg1m) {
        dt_start1m = dt_end1m + millisecondsInMinute;
        dt_end1m = dt_start1m + 5 * millisecondsInMinute;
        if (dt_end1m >= slider_7d_timeRange.value[1]) {
          dt_end1m = slider_7d_timeRange.value[1];
          isEndOfMsg1m = true;
          overlay.value = false;
        }
        log1m_reload_cnt = 0;
        pack1m_cnt++;
        progress_value.value = Math.floor(
          (pack1m_cnt / (slider_7d_estimated_datacount.value / 6)) * 100,
        );
        if (progress_value.value > 100) {
          progress_value.value = 100;
        }
        modbusStore.readLog1mData(
          modbusStore.deviceAddress,
          dt_start1m,
          dt_end1m,
        );
      } else {
        toggle_zoom.value = 0;
        chartUpdateData();
        chartUpdateOption();
        chartRedraw();
        show_data_file_title.value = device_data_title;
      }
    } else {
      if (log1m_reload_cnt < modbusStore.maxReloadCount) {
        modbusStore.readLog1mData(
          modbusStore.deviceAddress,
          dt_start1m,
          dt_end1m,
        );
        log1m_reload_cnt++;
      }
    }
  }
});

function startLog1sData() {
  load_data_1s_dlg.value = false;
  //------- Start Log1sData ------------
  modbusStore.clearLog1sData();
  modbusStore.clearLog100msData();
  slider_1s.value = [0, 100];
  isEndOfMsg1s = false;
  overlay.value = true;

  dt_start1s = slider_1m_timeRange.value[0];
  dt_end1s = slider_1m_timeRange.value[0] + 5 * millisecondsInSecond;
  if (dt_end1s >= slider_1m_timeRange.value[1]) {
    dt_end1s = slider_1m_timeRange.value[1];
    isEndOfMsg1s = true;
  }
  progress_value.value = 0;
  pack1s_cnt = 0;
  log1s_reload_cnt = 0;
  modbusStore.readLog1sData(modbusStore.deviceAddress, dt_start1s, dt_end1s);
}

let isEndOfMsg1s = false;
let pack1s_cnt = 0;
let log1s_reload_cnt = 0;
let dt_start1s = 0;
let dt_end1s = 0;
const log1sDataBusy = computed(() => {
  return modbusStore.log1sDataBusy;
});
watch(log1sDataBusy, (newVal) => {
  if (!newVal) {
    if (
      modbusStore.log1sDataIsOk ||
      log1s_reload_cnt == modbusStore.maxReloadCount
    ) {
      if (log1s_reload_cnt == modbusStore.maxReloadCount) {
        modbusStore.log1sDataTime.push(dt_start1s);
        modbusStore.log1sDataRP.push(null);
        modbusStore.log1sDataS1.push(null);
        modbusStore.log1sDataS2.push(null);
        modbusStore.log1sDataM12.push(null);
        modbusStore.log1sDataSetpoint.push(null);
        modbusStore.log1sDataV1.push(null);
        modbusStore.log1sDataV2.push(null);
        modbusStore.log1sDataTemp.push(null);
      }
      if (!isEndOfMsg1s) {
        dt_start1s = dt_end1s + millisecondsInSecond;
        dt_end1s = dt_start1s + 5 * millisecondsInSecond;
        if (dt_end1s >= slider_1m_timeRange.value[1]) {
          dt_end1s = slider_1m_timeRange.value[1];
          isEndOfMsg1s = true;
          overlay.value = false;
        }
        log1s_reload_cnt = 0;
        pack1s_cnt++;
        progress_value.value = Math.floor(
          (pack1s_cnt / ((slider_1m_estimated_datacount.value * 60) / 6)) * 100,
        );
        if (progress_value.value > 100) {
          progress_value.value = 100;
        }
        modbusStore.readLog1sData(
          modbusStore.deviceAddress,
          dt_start1s,
          dt_end1s,
        );
      } else {
        toggle_zoom.value = 1;
        chartUpdateData();
        chartUpdateOption();
        chartRedraw();
        show_data_file_title.value = device_data_title;
      }
    } else {
      if (log1s_reload_cnt < modbusStore.maxReloadCount) {
        modbusStore.readLog1sData(
          modbusStore.deviceAddress,
          dt_start1s,
          dt_end1s,
        );
        log1s_reload_cnt++;
      }
    }
  }
});

function startLog100msData() {
  load_data_100ms_dlg.value = false;
  //------- Start Log1sData ------------
  modbusStore.clearLog100msData();
  slider_100ms.value = [0, 100];
  isEndOfMsg100ms = false;
  overlay.value = true;

  dt_start100ms = slider_1s_timeRange.value[0];
  dt_end100ms = slider_1s_timeRange.value[0] + 5 * 100;
  if (dt_end100ms >= slider_1s_timeRange.value[1]) {
    dt_end100ms = slider_1s_timeRange.value[1];
    isEndOfMsg100ms = true;
  }
  progress_value.value = 0;
  pack100ms_cnt = 0;
  log100ms_reload_cnt = 0;
  modbusStore.readLog100msData(
    modbusStore.deviceAddress,
    dt_start100ms,
    dt_end100ms,
  );
}
let isEndOfMsg100ms = false;
let pack100ms_cnt = 0;
let log100ms_reload_cnt = 0;
let dt_start100ms = 0;
let dt_end100ms = 0;
const log100msDataBusy = computed(() => {
  return modbusStore.log100msDataBusy;
});
watch(log100msDataBusy, (newVal) => {
  if (!newVal) {
    if (
      modbusStore.log100msDataIsOk ||
      log100ms_reload_cnt == modbusStore.maxReloadCount
    ) {
      if (log100ms_reload_cnt == modbusStore.maxReloadCount) {
        modbusStore.log100msDataTime.push(dt_start1s);
        modbusStore.log100msDataRP.push(null);
        modbusStore.log100msDataS1.push(null);
        modbusStore.log100msDataS2.push(null);
        modbusStore.log100msDataM12.push(null);
        modbusStore.log100msDataSetpoint.push(null);
        modbusStore.log100msDataV1.push(null);
        modbusStore.log100msDataV2.push(null);
        modbusStore.log100msDataTemp.push(null);
      }
      if (!isEndOfMsg100ms) {
        dt_start100ms = dt_end100ms + 100;
        dt_end100ms = dt_start100ms + 5 * 100;
        if (dt_end100ms >= slider_1s_timeRange.value[1]) {
          dt_end100ms = slider_1s_timeRange.value[1];
          isEndOfMsg100ms = true;
          overlay.value = false;
        }
        log100ms_reload_cnt = 0;
        pack100ms_cnt++;
        progress_value.value = Math.floor(
          (pack100ms_cnt / ((slider_1s_estimated_datacount.value * 10) / 6)) *
            100,
        );
        if (progress_value.value > 100) {
          progress_value.value = 100;
        }
        modbusStore.readLog100msData(
          modbusStore.deviceAddress,
          dt_start100ms,
          dt_end100ms,
        );
      } else {
        toggle_zoom.value = 2;
        chartUpdateData();
        chartUpdateOption();
        chartRedraw();
        show_data_file_title.value = device_data_title;
      }
    } else {
      if (log100ms_reload_cnt < modbusStore.maxReloadCount) {
        modbusStore.readLog100msData(
          modbusStore.deviceAddress,
          dt_start100ms,
          dt_end100ms,
        );
        log100ms_reload_cnt++;
      }
    }
  }
});
//----------------------------------------------------------------------
const mouseDownPos = ref(0);
const mouseIsClick = ref(false);
const mouseMovepos = ref(0);
function onMouseDown(event: MouseEvent) {
  if (event.buttons == 1) {
    getChartSize();
    mouseIsClick.value = true;
    mouseDownPos.value = mouseMovepos.value;
  }
}
function onMouseUp(/* event: MouseEvent */) {
  mouseIsClick.value = false;
}
function onMouseMove(event: MouseEvent) {
  getChartSize();
  let slide_d = 1;
  if (toggle_zoom.value == 0) {
    slide_d = slider_1m.value[1] - slider_1m.value[0];
    mouseMovepos.value =
      (event.offsetX * slide_d) / chart_width + slider_1m.value[0];
    if (mouseIsClick.value) {
      const offsetX = mouseMovepos.value - mouseDownPos.value;
      const slider_range = slider_1m.value[1] - slider_1m.value[0];
      const slider_temp = [
        slider_1m.value[0] - offsetX,
        slider_1m.value[1] - offsetX,
      ];
      if (slider_temp[0] < 0) {
        slider_temp[0] = 0;
        slider_temp[1] = slider_temp[0] + slider_range;
      }
      if (slider_temp[1] > 100) {
        slider_temp[1] = 100;
        slider_temp[0] = 100 - slider_range;
      }
      if (
        slider_temp[0] != slider_1m.value[0] ||
        slider_temp[1] != slider_1m.value[1]
      ) {
        slider_1m.value = slider_temp;
        chartUpdateOption();
        chartRedraw();
      }
    }
  } else if (toggle_zoom.value == 1) {
    slide_d = slider_1s.value[1] - slider_1s.value[0];
    mouseMovepos.value =
      (event.offsetX * slide_d) / chart_width + slider_1s.value[0];
    if (mouseIsClick.value) {
      const offsetX = mouseMovepos.value - mouseDownPos.value;
      const slider_range = slider_1s.value[1] - slider_1s.value[0];
      const slider_temp = [
        slider_1s.value[0] - offsetX,
        slider_1s.value[1] - offsetX,
      ];
      if (slider_temp[0] < 0) {
        slider_temp[0] = 0;
        slider_temp[1] = slider_temp[0] + slider_range;
      }
      if (slider_temp[1] > 100) {
        slider_temp[1] = 100;
        slider_temp[0] = 100 - slider_range;
      }
      if (
        slider_temp[0] != slider_1s.value[0] ||
        slider_temp[1] != slider_1s.value[1]
      ) {
        slider_1s.value = slider_temp;
        chartUpdateOption();
        chartRedraw();
      }
    }
  } else if (toggle_zoom.value == 2) {
    slide_d = slider_100ms.value[1] - slider_100ms.value[0];
    mouseMovepos.value =
      (event.offsetX * slide_d) / chart_width + slider_100ms.value[0];
    if (mouseIsClick.value) {
      const offsetX = mouseMovepos.value - mouseDownPos.value;
      const slider_range = slider_100ms.value[1] - slider_100ms.value[0];
      const slider_temp = [
        slider_100ms.value[0] - offsetX,
        slider_100ms.value[1] - offsetX,
      ];
      if (slider_temp[0] < 0) {
        slider_temp[0] = 0;
        slider_temp[1] = slider_temp[0] + slider_range;
      }
      if (slider_temp[1] > 100) {
        slider_temp[1] = 100;
        slider_temp[0] = 100 - slider_range;
      }
      if (
        slider_temp[0] != slider_100ms.value[0] ||
        slider_temp[1] != slider_100ms.value[1]
      ) {
        slider_100ms.value = slider_temp;
        chartUpdateOption();
        chartRedraw();
      }
    }
  }
}

function onMouseScroll(event: WheelEvent) {
  event.preventDefault();
  const wheelDelta = -event.deltaY;
  const rate = 1.3;
  let slide = [0, 100];
  let slide_d_s = 0;
  let slide_d_e = 0;
  let slide_alltime = 1;
  let limit_time = 1;
  if (toggle_zoom.value == 0) {
    slide = slider_1m.value;
    slide_d_s = mouseMovepos.value - slider_1m.value[0];
    slide_d_e = slider_1m.value[1] - mouseMovepos.value;
    slide_alltime = slider_7d_timeRange.value[1] - slider_7d_timeRange.value[0];
    limit_time = slide_limit_time_1m;
  } else if (toggle_zoom.value == 1) {
    slide = slider_1s.value;
    slide_d_s = mouseMovepos.value - slider_1s.value[0];
    slide_d_e = slider_1s.value[1] - mouseMovepos.value;
    slide_alltime = slider_1m_timeRange.value[1] - slider_1m_timeRange.value[0];
    limit_time = slide_limit_time_1s;
  } else if (toggle_zoom.value == 2) {
    slide = slider_100ms.value;
    slide_d_s = mouseMovepos.value - slider_100ms.value[0];
    slide_d_e = slider_100ms.value[1] - mouseMovepos.value;
    slide_alltime = slider_1s_timeRange.value[1] - slider_1s_timeRange.value[0];
    limit_time = slide_limit_time_100ms;
  }

  let enabled_chart_redraw = false;
  //--- Zoom Out ---------
  if (wheelDelta < 0) {
    if (slide[0] > 0) {
      slide[0] = mouseMovepos.value - slide_d_s * rate;
      if (slide[0] < 0) {
        slide[0] = 0;
      }
      enabled_chart_redraw = true;
    }
    if (slide[1] < 100) {
      slide[1] = mouseMovepos.value + slide_d_e * rate;
      if (slide[1] > 100) {
        slide[1] = 100;
      }
      enabled_chart_redraw = true;
    }
  }
  //--- Zoom In ---------
  if (wheelDelta > 0) {
    if ((slide_alltime * (slide[1] - slide[0])) / 100 >= limit_time) {
      slide[0] = mouseMovepos.value - slide_d_s / rate;
      slide[1] = mouseMovepos.value + slide_d_e / rate;
      enabled_chart_redraw = true;
    }
  }
  if (toggle_zoom.value == 0) {
    slider_1m.value = slide;
  } else if (toggle_zoom.value == 1) {
    slider_1s.value = slide;
  } else if (toggle_zoom.value == 2) {
    slider_100ms.value = slide;
  }
  if (enabled_chart_redraw) {
    chartUpdateOption();
    chartRedraw();
  }
}
//---------------------------------------------------------
const device_data_title = "--- not saved ---";
const save_file_name = ref("");
const save_dialog = ref(false);
const save_file_err_msg = ref("");
// const loadingBtnSave = ref(false);
const show_data_file_title = ref("");
// watch(show_data_file_title, (newVal) => {
//   modbusStore.show_data_file_title = newVal;
// });
function onButtonClickSave() {
  save_file_name.value = "";
  save_file_err_msg.value = "";
  save_dialog.value = true;
  // loadingBtnSave.value = true;
}
function download_save_data() {
  if (save_file_name.value == "") {
    save_file_err_msg.value = "Field is required";
  } else {
    const chartInfo = {
      slider_7d: slider_7d.value,
      slider_1m: slider_1m.value,
      slider_1s: slider_1s.value,
      slider_100ms: slider_100ms.value,
      toggle_zoom: toggle_zoom.value,
      log7dMinTime: modbusStore.log7dMinTime,
      log7dMaxTime: modbusStore.log7dMaxTime,
      log1mDataTime: modbusStore.log1mDataTime,
      log1mDataRP: modbusStore.log1mDataRP,
      log1mDataS1: modbusStore.log1mDataS1,
      log1mDataS2: modbusStore.log1mDataS2,
      log1mDataM12: modbusStore.log1mDataM12,
      log1mDataSetpoint: modbusStore.log1mDataSetpoint,
      log1mDataV1: modbusStore.log1mDataV1,
      log1mDataV2: modbusStore.log1mDataV2,
      log1mDataTemp: modbusStore.log1mDataTemp,
      log1sDataTime: modbusStore.log1sDataTime,
      log1sDataRP: modbusStore.log1sDataRP,
      log1sDataS1: modbusStore.log1sDataS1,
      log1sDataS2: modbusStore.log1sDataS2,
      log1sDataM12: modbusStore.log1sDataM12,
      log1sDataSetpoint: modbusStore.log1sDataSetpoint,
      log1sDataV1: modbusStore.log1sDataV1,
      log1sDataV2: modbusStore.log1sDataV2,
      log1sDataTemp: modbusStore.log1sDataTemp,
      log100msDataTime: modbusStore.log100msDataTime,
      log100msDataRP: modbusStore.log100msDataRP,
      log100msDataS1: modbusStore.log100msDataS1,
      log100msDataS2: modbusStore.log100msDataS2,
      log100msDataM12: modbusStore.log100msDataM12,
      log100msDataSetpoint: modbusStore.log100msDataSetpoint,
      log100msDataV1: modbusStore.log100msDataV1,
      log100msDataV2: modbusStore.log100msDataV2,
      log100msDataTemp: modbusStore.log100msDataTemp,
    };
    const blob = new Blob([JSON.stringify(chartInfo)], {
      type: "application/json",
    });
    // saveAs.saveAs(blob, save_file_name.value + ".eqda");
    saveAs.saveAs(blob, save_file_name.value + ".eqda");
    show_data_file_title.value = save_file_name.value + ".eqda";
    save_dialog.value = false;
    // loadingBtnSave.value = false;
  }
}

const openFile = ref();
const open_file_key = ref("open_file_" + new Date().getTime());
const loadingBtnOpen = ref(false);
function onButtonClickOpen() {
  loadingBtnOpen.value = true;
  window.addEventListener(
    "focus",
    () => {
      loadingBtnOpen.value = false;
    },
    { once: true },
  );
  openFile.value.click();
}

function readFile(event: ProgressEvent<FileReader>) {
  const result = event.target?.result ?? "";
  const chartInfo = JSON.parse(
    typeof result === "string" ? result : new TextDecoder().decode(result),
  );
  slider_7d.value = chartInfo.slider_7d;
  slider_1m.value = chartInfo.slider_1m;
  slider_1s.value = chartInfo.slider_1s;
  slider_100ms.value = chartInfo.slider_100ms;
  toggle_zoom.value = chartInfo.toggle_zoom;
  modbusStore.log7dMinTime = chartInfo.log7dMinTime;
  modbusStore.log7dMaxTime = chartInfo.log7dMaxTime;
  modbusStore.log1mDataTime = chartInfo.log1mDataTime;
  modbusStore.log1mDataRP = chartInfo.log1mDataRP;
  modbusStore.log1mDataS1 = chartInfo.log1mDataS1;
  modbusStore.log1mDataS2 = chartInfo.log1mDataS2;
  modbusStore.log1mDataM12 = chartInfo.log1mDataM12;
  modbusStore.log1mDataSetpoint = chartInfo.log1mDataSetpoint;
  modbusStore.log1mDataV1 = chartInfo.log1mDataV1;
  modbusStore.log1mDataV2 = chartInfo.log1mDataV2;
  modbusStore.log1mDataTemp = chartInfo.log1mDataTemp;
  modbusStore.log1sDataTime = chartInfo.log1sDataTime;
  modbusStore.log1sDataRP = chartInfo.log1sDataRP;
  modbusStore.log1sDataS1 = chartInfo.log1sDataS1;
  modbusStore.log1sDataS2 = chartInfo.log1sDataS2;
  modbusStore.log1sDataM12 = chartInfo.log1sDataM12;
  modbusStore.log1sDataSetpoint = chartInfo.log1sDataSetpoint;
  modbusStore.log1sDataV1 = chartInfo.log1sDataV1;
  modbusStore.log1sDataV2 = chartInfo.log1sDataV2;
  modbusStore.log1sDataTemp = chartInfo.log1sDataTemp;
  modbusStore.log100msDataTime = chartInfo.log100msDataTime;
  modbusStore.log100msDataRP = chartInfo.log100msDataRP;
  modbusStore.log100msDataS1 = chartInfo.log100msDataS1;
  modbusStore.log100msDataS2 = chartInfo.log100msDataS2;
  modbusStore.log100msDataM12 = chartInfo.log100msDataM12;
  modbusStore.log100msDataSetpoint = chartInfo.log100msDataSetpoint;
  modbusStore.log100msDataV1 = chartInfo.log100msDataV1;
  modbusStore.log100msDataV2 = chartInfo.log100msDataV2;
  modbusStore.log100msDataTemp = chartInfo.log100msDataTemp;
  chartUpdateData();
  chartUpdateOption();
  chartRedraw();
  open_file_key.value = "open_file_" + new Date().getTime();
}

function onFileOpenChanged(e: Event) {
  if (e.target instanceof HTMLInputElement && e.target.files?.[0]) {
    show_data_file_title.value = e.target.files[0].name;
    const reader = new FileReader();
    reader.addEventListener("load", readFile);
    reader.readAsText(e.target.files[0]);
  }
}
</script>

<style scoped lang="scss">
.loading-overlay {
  background: rgb(0, 0, 0, 0.5);
}

.under-construction-overlay {
  background: rgb(0, 0, 0, 0.4);
  left: var(--v-layout-left);
}
</style>
